import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ListLine } from "../framework/listLine";
import { ITaskListItem } from "../../models/task/taskListItem";
import { Translations } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/translations";

export interface ITaskListStateColProp {
    item: ITaskListItem;
}

export class TaskListStateCol extends React.Component<ITaskListStateColProp, {}> {
    render() {
        const nowDate = Date.now();
        const item = this.props.item;
        return (
            <div className="flex WithIcons jend">
                {(nowDate - item.modifyDate) <= Base.oneHourInMs &&
                    <span className="icon fresh" title={Translations.RecentlyUpdated}></span>
                }
                {item.locked &&
                    <span className="icon locked" title={Translations.Locked}></span>
                }
                {item.calendarTaskCount > 0 &&
                    <span className="icon notification" title={`${Translations.OpenCalendarTasks}: ${item.calendarTaskCount}`}></span>
                }
                <span className={"stateText task state" + item.stateSortOrder.toString(10)} style={{ background: item.stateColor }}>{item.stateCode}</span>
            </div>
        );
    }
}

//TaskListLine
export interface ITaskListLineProp {
    item: ITaskListItem;
    selected: boolean;
    first: boolean;
    isLastOpenedTask: boolean;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onRefreshList: () => void;
}

export class TaskListLine extends React.Component<ITaskListLineProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        if (item.isTitle) {
            return (
                <ListLine
                    id={item.id}
                    first={props.first}
                    selected={false}
                    classes={"line dataTitle" + (!Base.isNullOrEmpty(item.titleClass) ? " " + item.titleClass : "")}
                    onClick={() => {}}
                    onLongPress={() => {}}
                    onRefreshList={props.onRefreshList}>
                    <div className="row">
                        <div className="col col-12">{item.name}</div>
                    </div>
                </ListLine>
            );
        }
        return (
            <ListLine
                id={item.id}
                first={props.first}
                selected={props.selected}
                classes={"line ts s" + item.stateSortOrder + (this.props.selected ? " selected" : "") + (props.isLastOpenedTask ? " lot" : "")}
                onClick={props.onClick}
                onLongPress={props.onLongPress}
                onRefreshList={props.onRefreshList}>
                <div className="row">
                    <div className="col col-12">
                        <span className="bold">
                            {item.name}
                        </span>
                    </div>
                </div>
                <div className="row sub">
                    <div className="col col-5">{item.typeCode + (!Base.isNullOrEmpty(item.priorityCode) ? " / " + item.priorityCode : "")}</div>
                    <div className="col col-7"><TaskListStateCol item={item} /></div>
                </div>
            </ListLine>
        );
    }
}